import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { fontWeight, spacing, color, fontSize, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

const Label = styled(Box).attrs(() => ({ as: "label" }))`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: ${fontWeight("bold")};
    margin-bottom: ${spacing("xs")};
    color: ${color(`text.base`)};
`;
const Description = styled(Box)`
    margin-bottom: ${spacing("xs")};
    margin-top: -${spacing("xs")};
`;
const ValidationMessage = styled(Box)`
    font-size: ${fontSize("sm")};
    margin-top: ${spacing("xs")};
    margin-bottom: ${spacing("xs")};

    ${({ isInvalid }) => isInvalid && css`
            color: ${palette("danger.500")};
        `}

    ${({ isValid }) => isValid && css`
            color: ${palette("success.500")};
        `}
`;
const HelpText = styled(Box)`
    color: ${color("text.low")};
    font-size: ${fontSize("sm")};
    margin-top: ${spacing("xs")};
    margin-bottom: ${spacing("xs")};
`;
const FormControl = styled(Box)`
    width: 100%;

    & + & {
        margin-top: ${spacing("sm")};
    }
`;

export { Description, FormControl, HelpText, Label, ValidationMessage };
//# sourceMappingURL=styled.es.js.map
